import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const Backdrop = styled.div`
  background: #00000088;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  max-height: 100%;
  overflow-y: auto;
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1140;
`;


class Modal extends React.Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
  };

  render() {
    const {open, onClose, ...props} = this.props;

    if (!open) {
      return null;
    }

    return (
      <Container {...props}>
        <Backdrop onClick={onClose}/>
        <Content>
          {this.props.children}
        </Content>
      </Container>
    );
  }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/shared/Modal/index.js